// Dynamic Stretches — Pre-Workout Warm-Up Routine
// Extracted from LE PROTOCOL dynamic stretch guide

export const DYNAMIC_STRETCHES = [
  {
    id: 'squats',
    name: 'Squats',
    reps: '15 reps',
    instruction: 'Feet shoulder-width apart, sit back into hips, drive through heels.',
    muscle: 'Quads / Glutes / Core',
  },
  {
    id: 'high-knees',
    name: 'High Knees',
    reps: '30 seconds',
    instruction: 'Drive knees to chest level, pump arms, stay on balls of feet.',
    muscle: 'Hip Flexors / Quads',
  },
  {
    id: 'leg-swings',
    name: 'Leg Swings',
    reps: '12 each leg',
    instruction: 'Hold support, swing leg forward and back in controlled arc.',
    muscle: 'Hip Flexors / Hamstrings',
  },
  {
    id: 'lunges',
    name: 'Lunges',
    reps: '10 each leg',
    instruction: 'Step forward, lower back knee toward floor, front knee over ankle.',
    muscle: 'Quads / Glutes / Balance',
  },
  {
    id: 'plank-walkouts',
    name: 'Plank Walk-Outs',
    reps: '8 reps',
    instruction: 'From standing, hinge down, walk hands to plank, walk back up.',
    muscle: 'Core / Shoulders / Hamstrings',
  },
  {
    id: 'arm-circles',
    name: 'Arm Circles',
    reps: '15 each direction',
    instruction: 'Arms extended, small circles forward then reverse. Gradually widen.',
    muscle: 'Shoulders / Rotator Cuff',
  },
  {
    id: 'standing-toe-taps',
    name: 'Standing Toe Taps',
    reps: '12 each side',
    instruction: 'Kick leg up, tap toe with opposite hand. Alternate sides.',
    muscle: 'Hamstrings / Core / Hip Flexors',
  },
  {
    id: 'jumping-jacks',
    name: 'Jumping Jacks',
    reps: '30 seconds',
    instruction: 'Jump feet wide while raising arms overhead. Return and repeat.',
    muscle: 'Full Body / Cardio',
  },
  {
    id: 'butt-kicks',
    name: 'Butt Kicks',
    reps: '30 seconds',
    instruction: 'Jog in place, flick heels up to glutes, keep torso upright.',
    muscle: 'Hamstrings / Quads',
  },
  {
    id: 'hip-circles',
    name: 'Hip Circles',
    reps: '10 each direction',
    instruction: 'Hands on hips, make wide circles. Clockwise then counter-clockwise.',
    muscle: 'Hip Flexors / Glutes / Lower Back',
  },
];
